import { bind } from 'decko'
import { LiveElement, LiveNodeList } from 'live-node-list'
import { goToSlide } from './slideshow-helpers'

export default class Founders {
  founders = new LiveNodeList('.founders .founders__more-link')
  closeButtons = new LiveNodeList('.founder-modal__close-button')

  constructor() {
    if (this.founders.length === 0) {
      return
    }

    this.registerListeners()
  }

  @bind
  registerListeners() {
    this.founders.forEach(container => {
      this.founders.addEventListener('click', this.openModal)
    })
    this.closeButtons.forEach(container => {
      this.closeButtons.addEventListener('click', this.closeModal)
    })
  }

  @bind
  openModal() {
    const target = event.currentTarget || event.target
    const modal = document.querySelector(
      `#${target.getAttribute('data-block')}`,
    )

    modal.setAttribute('aria-hidden', false)

    const slideshow = modal.querySelector('.founder-modal__slides')
    goToSlide(slideshow, 0, true)
  }

  @bind
  closeModal() {
    const target = event.currentTarget || event.target
    target.parentNode.parentNode.setAttribute('aria-hidden', true)
  }
}
